import { map } from 'rxjs';

import { componentOutletConfigFactory } from '@recruitee/common';
import { injectTranslate } from '@recruitee/i18n';
import { EMPTY_CELL, UserCellComponent } from '@recruitee/user-interface';
import { injectUntilDestroyed } from '@recruitee/utils';

import { OfferColumnId } from '../../../offers-page/offers-table/offers.table-service';
import { defineOfferTableColumn, injectUsersMap } from './utils';

export const recruiterColumn = defineOfferTableColumn(() => {
  const usersMap = injectUsersMap();
  return {
    id: OfferColumnId.Recruiter,
    label: injectTranslate()('app.offers.table.recruiter'),
    visible: false,
    geometry: {
      width: 160,
      minWidth: 120,
      autoFitProp: 'width',
    },
    options: {
      draggable: false,
      resizable: true,
      removable: true,
      sortable: false,
    },
    componentFactory: ({ row }) => {
      if (!row.recruiterId) return EMPTY_CELL;

      return usersMap.pipe(
        map(users =>
          componentOutletConfigFactory(UserCellComponent, {
            inputs: { user: users[row.recruiterId!] },
          }),
        ),
        injectUntilDestroyed(),
      );
    },
  };
});
